export class ChatMessage {
  id?: number;
  sender: string;
  text: string;
  type: string;
  currentTime: string;
  source: string;
  elapsedTime: string;

  // constructor(sender: string, text: string, type: string, currentTime: string, source: string, elapsedTime: string) {
  //   this.sender = sender;
  //   this.text = text;
  //   this.type = type;
  //   this.currentTime = currentTime;
  //   this.source = source;
  //   this.elapsedTime = elapsedTime;
  // }

  constructor(id: number, sender: string, text: string, type: string, currentTime: string, source: string, elapsedTime: string) {
    this.id = id;
    this.sender = sender;
    this.text = text;
    this.type = type;
    this.currentTime = currentTime;
    this.source = source;
    this.elapsedTime = elapsedTime;
  }
}

export enum MessageTypeEnum {
  TEXT = 'text',
  AUDIO = 'audio',
}

export enum MessageSenderTypeEnum {
  bot = 'bot',
  user = 'user',
}
